export default __webpack_public_path__ + "static/background_mobile-bca07e5da5744813a402102710561c5b.webp";